<router-outlet></router-outlet>
<app-popup-host></app-popup-host>
